export default __webpack_public_path__ + "static/media/mobisha.316c23bc.svg";